import React from "react";
import { useRefs } from "@/lib/useRefs";
import { PageHeader } from "@/components/Common";
import AdminWhatsNew from "@/pages/admin/AdminWhatsNew";

export default function ConsoleWhatsNew() {
  const refs = useRefs();
  return (
    <div>
      <PageHeader
        eyebrow={<span className="flex items-center gap-1.5">Console · What's New</span>}
        title="Announcements"
        subtitle="Post releases, workflow changes and announcements. Each entry targets a program and reaches everyone assigned to it."
        testid="console-whatsnew-header" />
      <AdminWhatsNew refs={refs} />
    </div>
  );
}
